<template>
  <div class="popRule">
    <Scroll class="abs ruleCont">
      <p>1、活动名称：【幻塔真的有毒】幻塔三周年，“毒性”头像大派发</p>
      <p>2、活动时间：2024年12月12日12:00至2024年12月31日23:59</p>
      <p>3、参与资格：注册有《幻塔》游戏角色的用户</p>
      <p>4、参与方式：用户每日登录活动H5，即可根据活动页面指示参与头像抽取，完成头像图鉴收集，解锁更多道具奖励。</p>
      <p>5、抽取与集齐：</p>
      <p>（1）用户每日登录H5活动，都会在【抽头像】页面获得3次扭蛋次数和3次好友助力的机会（每日23:59刷新次数），每次好友助力都会增加1次扭蛋次数。</p>
      <p>（2）每1次扭蛋都能随机抽取5个头像，抽取头像可重复，共可抽取到33个不同的头像。每10次扭蛋必出1个未拥有头像。</p>
      <p>（3）所有已解锁头像都会显示在【集头像】页面，用户分别集齐3\13\23\33个不同头像，即可领取对应奖励。</p>
      <p>6、奖品发放：</p>
      <p>（1）玩家在活动中获得的头像与道具奖励，均会通过游戏邮件发放至游戏端内，每个绑定账号仅可领取一次（活动期间，用户游戏等级需达到10级，才能正常开启游戏内邮箱功能，领取邮箱内奖励）</p>
      <p>（2）邮件发放可能存在延时，如果已在活动中完成头像与奖励的领取，请耐心等待。</p>
    </Scroll>
  </div>
</template>

<script>
import Scroll from '@/components/scroll/Scroll.vue'
export default {
  components: {
    Scroll
  }
}
</script>

<style scoped>
.popRule{ width: 727px; height: 1046px; background: url(@images/popRule.png) no-repeat 0 0;}
.ruleCont{ top: 190px; left: 70px; width: 629px; height: 753px; box-sizing: border-box; padding-right: 55px; line-height: 46px; font-size: 30px; color: #625671;}
</style>